import React, { useMemo } from 'react';
import { Flex, Typography } from '@banhala/ui-kit';
import type { HeadlineSmallOneLineWithTextProps } from './types';
import { isNil, renderHTMLToText } from '../../../../utils';

export const HeadlineSmallOneLineWithText: React.FC<
  HeadlineSmallOneLineWithTextProps
> = ({ header }) => {
  const textElement = useMemo(() => {
    if (isNil(header)) return null;

    return renderHTMLToText(header.item.text);
  }, [header]);

  if (!header) return null;

  return (
    <Flex.Row
      padding={{ horizontal: 16, vertical: 16 }}
      justifyContent={'space-between'}
      alignItems={'center'}
      testID={header.item.title}
    >
      <Typography type="subtitle1" color="content_primary">
        {header.item.title}
      </Typography>

      {textElement}
    </Flex.Row>
  );
};
